import React from 'react'
import { withRouter } from 'react-router'
import jwtDecoder from 'jwt-decode'

import { LOGOUT_URL_PATH } from '../constants'

export const AuthContext = React.createContext()

class AuthProvider extends React.Component {
  constructor (props) {
    super(props)

    this.signOut = async () => {
      // get legacy token - we will have to redirect to the legacy sign out page is this has a value
      const legacyToken = this.getToken();

      // remove v3 auth
      document.cookie = `auth_token=; Domain=${process.env.AUTH_COOKIE_DOMAIN}; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Secure; SameSite=None;`;
      window.localStorage.removeItem('user');
      window.localStorage.removeItem('nav-collapsed');

      if (legacyToken) {
        window.history.pushState({}, '', LOGOUT_URL_PATH);
        window.location.reload();
      } else {
        // redirect to login screen
        let url = process.env.DASHBOARD_V3_URL + '/sign-in';

        if (window.location.pathname) {
          url += `?returnUrl=${window.location.pathname}`;
        }

        window.location.replace(url);
      }
    }

    const token = this.getToken('auth_token');
    let jwt = {};
    if (token) {
      jwt = jwtDecoder(token);
    }

    this.state = {
      token: token,
      signOut: this.signOut,
      userId: jwt.user_id,
      name: jwt.name,
      role: jwt.role_id,
      email: jwt.email,
      countryCode: jwt.country_code
    }
  }

  getToken = (name = 'token') => {
    try {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith(name))
        .split('=')[1];
    } catch (e) {
      return '';
    }
  }

  handleToken = async (token) => {
    const decodedToken = await jwtDecoder(token);
    const roleId = decodedToken.role_id;
    const userId = decodedToken.user_id;
    const { name, email, exp } = decodedToken;

    this.setState({
      token,
      name,
      role: roleId,
      email,
      userId: userId,
      countryCode: decodedToken.country_code
    });
  };

  componentDidMount () {
    let token = this.getToken();
    if (token) {
      // if we have an existing token - log the user out
      this.signOut(token);
    } else {
      // this token is created by the new auth screen
      token = this.getToken('auth_token');
      if (token) {
        this.handleToken(token)
      } else {
        // redirect to login screen
        const url = process.env.DASHBOARD_V3_URL + '/sign-in';
        window.location.replace(url);
      }
    }
  }

  render () {
    return (
      <AuthContext.Provider value={this.state}>
        {this.props.children}
      </AuthContext.Provider>
    )
  }
}

export default withRouter(AuthProvider);
